import PropTypes from 'prop-types';
import React, { Component } from 'react';
// import { Link } from 'react-router';
import { connect } from 'react-redux';
import { AuthActions } from '../actions/auth';
import logo from '../static/img/logo.png';
// import intl from '../mixins/intl';
// import Message from '../components/formatters/Message';

import '../styles/NavBar.css';

class NavBar extends Component {
  static propTypes = {
    user: PropTypes.object.isRequired,
  };

  static contextTypes = {
    store: PropTypes.object.isRequired,
  };

  handleLogout(e) {
    e.preventDefault();
    this.context.store.dispatch(AuthActions.logout());
  }

  render() {
    return (
      <nav className="navbar navbar-light bg-faded navbar-fixed-top top-sight-nav">
        <div className="navbar-header pull-left">
          <img
            src={logo}
            width="81"
            height="30"
            className="nav-logo"
            alt="Sight Logo"
          />
        </div>
      </nav>
    );
  }
}

@connect(state => ({}))
export default class NavBarContainer extends Component {
  static propTypes = {};

  render() {
    const { user, project } = this.props;

    return <NavBar user={user} project={project} />;
  }
}



// WEBPACK FOOTER //
// ./src/components/NavBarLoggedOut.js